import React from 'react'

export default function nopg() {
  return (
    <div>404 error</div>
  )
}
